import apiClient from './api';

export interface Size {
  id?: number;
  name: string;
  code?: string;
  description?: string;
  status?: boolean | number;
  created_by?: number;
  updated_by?: number;
  created_at?: string;
  updated_at?: string;
}

export const sizeService = {
  // Get all sizes
  async getSizes(): Promise<Size[]> {
    try {
      const response = await apiClient.get('/sizes');
      return response.data;
    } catch (error) {
      console.error('Error fetching sizes:', error);
      throw error;
    }
  },

  // Get single size by ID
  async getSize(id: number): Promise<Size> {
    try {
      const response = await apiClient.get(`/sizes/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching size ${id}:`, error);
      throw error;
    }
  },

  // Create new size
  async createSize(size: Omit<Size, 'id'>): Promise<Size> {
    try {
      const response = await apiClient.post('/sizes', size);
      return response.data.data;
    } catch (error) {
      console.error('Error creating size:', error);
      throw error;
    }
  },

  // Update existing size
  async updateSize(id: number, size: Partial<Size>): Promise<Size> {
    try {
      const response = await apiClient.put(`/sizes/${id}`, size);
      return response.data.data;
    } catch (error) {
      console.error(`Error updating size ${id}:`, error);
      throw error;
    }
  },

  // Delete size
  async deleteSize(id: number): Promise<void> {
    try {
      await apiClient.delete(`/sizes/${id}`);
    } catch (error) {
      console.error(`Error deleting size ${id}:`, error);
      throw error;
    }
  },
};
